<div class="p-2 absolute left-0 z-50 h-screen flex flex-col justify-start">
	<div class="relative group inline-block">
		<button
			class="bg-peps-gold rounded-full p-2 cursor-pointer shadow-md"
			(click)="toHome()"
		>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				fill="none"
				viewBox="0 0 24 24"
				stroke-width="1.5"
				stroke="currentColor"
				class="size-6"
			>
				<path
					stroke-linecap="round"
					stroke-linejoin="round"
					d="M9 15 3 9m0 0 6-6M3 9h12a6 6 0 0 1 0 12h-3"
				/>
			</svg>
		</button>
		<div class="absolute -right-2 top-1/2 transform translate-x-full -translate-y-1/2 px-2 py-1 text-xs text-white bg-peps-dark-800 rounded opacity-0 group-hover:opacity-100 transition-opacity uppercase text-nowrap">
			{{ 'page.place.buttons.back' | translate }}
		</div>
	</div>
</div>

@if(selectedPixel()) {
	<div class="border-2 border-peps-gold absolute top-4 left-1/2 -translate-x-1/2  text-peps-dark-600 z-50 w-fit h-fit py-2 px-4 font-notosans bg-peps-text-10">
		<div class="flex flex-col items-center justify-center h-full">
			<span>
				X={{ selectedPixel()?.x }} - Y={{ selectedPixel()?.y }}
			</span>
			@if(selectedPixel()!.username) {
				<span class="text-sm text-peps-dark-400">
					{{ 'page.place.pixel-info.draw-by' | translate }} : {{ selectedPixel()?.username }}
				</span>
				<span class="text-sm text-peps-dark-400/80">
					{{ $safeNavigationMigration(selectedPixel()?.placedAt) | date:'dd/MM/yy HH:mm' }}
				</span>
			} @else {
				<span class="text-sm text-peps-dark-400/80">
					{{ 'page.place.pixel-info.no-draw' | translate }}
				</span>
			}
		</div>
	</div>
}

<div class="p-4 absolute right-0 z-50 h-screen flex flex-col justify-start gap-8">

	<div class="flex flex-col gap-4">

		<div class="relative group inline-block">
			<button
				class="bg-peps-gold rounded-full p-2 cursor-pointer shadow-md"
				(click)="openLeaderboardModal()"
			>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-8">
					<path d="M18.375 2.25c-1.035 0-1.875.84-1.875 1.875v15.75c0 1.035.84 1.875 1.875 1.875h.75c1.035 0 1.875-.84 1.875-1.875V4.125c0-1.036-.84-1.875-1.875-1.875h-.75ZM9.75 8.625c0-1.036.84-1.875 1.875-1.875h.75c1.036 0 1.875.84 1.875 1.875v11.25c0 1.035-.84 1.875-1.875 1.875h-.75a1.875 1.875 0 0 1-1.875-1.875V8.625ZM3 13.125c0-1.036.84-1.875 1.875-1.875h.75c1.036 0 1.875.84 1.875 1.875v6.75c0 1.035-.84 1.875-1.875 1.875h-.75A1.875 1.875 0 0 1 3 19.875v-6.75Z" />
				</svg>
			</button>
			<div class="absolute -left-2 top-1/2 transform -translate-x-full -translate-y-1/2 px-2 py-1 text-xs text-white bg-peps-dark-800 rounded opacity-0 group-hover:opacity-100 transition-opacity uppercase text-nowrap">
				{{ 'page.place.buttons.leaderboard' | translate }}
			</div>
		</div>

		@if(authService.isAuthenticated()) {
			<div class="relative group inline-block">
				<button
					class="bg-peps-gold rounded-full p-2 cursor-pointer shadow-md"
					(click)="openChallengeModal()"
				>
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-8">
						<path fill-rule="evenodd" d="M9 4.5a.75.75 0 0 1 .721.544l.813 2.846a3.75 3.75 0 0 0 2.576 2.576l2.846.813a.75.75 0 0 1 0 1.442l-2.846.813a3.75 3.75 0 0 0-2.576 2.576l-.813 2.846a.75.75 0 0 1-1.442 0l-.813-2.846a3.75 3.75 0 0 0-2.576-2.576l-2.846-.813a.75.75 0 0 1 0-1.442l2.846-.813A3.75 3.75 0 0 0 7.466 7.89l.813-2.846A.75.75 0 0 1 9 4.5ZM18 1.5a.75.75 0 0 1 .728.568l.258 1.036c.236.94.97 1.674 1.91 1.91l1.036.258a.75.75 0 0 1 0 1.456l-1.036.258c-.94.236-1.674.97-1.91 1.91l-.258 1.036a.75.75 0 0 1-1.456 0l-.258-1.036a2.625 2.625 0 0 0-1.91-1.91l-1.036-.258a.75.75 0 0 1 0-1.456l1.036-.258a2.625 2.625 0 0 0 1.91-1.91l.258-1.036A.75.75 0 0 1 18 1.5ZM16.5 15a.75.75 0 0 1 .712.513l.394 1.183c.15.447.5.799.948.948l1.183.395a.75.75 0 0 1 0 1.422l-1.183.395c-.447.15-.799.5-.948.948l-.395 1.183a.75.75 0 0 1-1.422 0l-.395-1.183a1.5 1.5 0 0 0-.948-.948l-1.183-.395a.75.75 0 0 1 0-1.422l1.183-.395c.447-.15.799-.5.948-.948l.395-1.183A.75.75 0 0 1 16.5 15Z" clip-rule="evenodd" />
					</svg>
				</button>
				<div class="absolute -left-2 top-1/2 transform -translate-x-full -translate-y-1/2 px-2 py-1 text-xs text-white bg-peps-dark-800 rounded opacity-0 group-hover:opacity-100 transition-opacity uppercase text-nowrap">
					{{ 'page.place.buttons.challenges' | translate }}
				</div>
			</div>
		}

		<div class="relative group inline-block">
			<button
				class="bg-peps-gold rounded-full p-2 cursor-pointer shadow-md"
				(click)="download()"
			>
				<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-8">
					<path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
				</svg>
			</button>
			<div class="absolute -left-2 top-1/2 transform -translate-x-full -translate-y-1/2 px-2 py-1 text-xs text-white bg-peps-dark-800 rounded opacity-0 group-hover:opacity-100 transition-opacity uppercase text-nowrap">
				{{ 'page.place.buttons.download' | translate }}
			</div>
		</div>

		<div class="relative group inline-block">
			<button
				class="bg-peps-dark-300/60 rounded-full p-2 cursor-not-allowed shadow-md"
			>
				<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-8">
					<path stroke-linecap="round" stroke-linejoin="round" d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z" />
				</svg>

				<div class="absolute -left-2 top-1/2 transform -translate-x-full -translate-y-1/2 px-2 py-1 text-xs text-white bg-peps-dark-800 rounded opacity-0 group-hover:opacity-100 transition-opacity uppercase text-nowrap">
					<span>{{ 'page.place.buttons.coming-soon' | translate }}</span>
				</div>
			</button>
		</div>

		<div class="relative group inline-block">
			<button
				class="bg-peps-gold rounded-full p-2 cursor-pointer shadow-md"
				(click)="openInformationModal()"
			>
				<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-8">
					<path stroke-linecap="round" stroke-linejoin="round" d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z" />
				</svg>
			</button>
			<div class="absolute -left-2 top-1/2 transform -translate-x-full -translate-y-1/2 px-2 py-1 text-xs text-white bg-peps-dark-800 rounded opacity-0 group-hover:opacity-100 transition-opacity uppercase text-nowrap">
				{{ 'page.place.buttons.what-is-pplace' | translate }}
			</div>
		</div>

	</div>


</div>

<div class="absolute bottom-0 left-0 w-screen h-fit z-50 flex flex-col" [ngClass]="{'bg-peps-text-10': isShowingColoursSelector()}">
	<div class="flex flex-row drop-shadow-md self-center mt-2">
		@if(authService.isAuthenticated()) {
			<div class="relative group inline-block">
				<button
					(click)="validPixels()"
					class="p-4 h-14"
					[disabled]="localPixelsAvailable() == 10"
					[ngClass]="{'bg-green-500 cursor-pointer': localPixelsPlaced > 0, 'bg-gray-500 cursor-not-allowed': localPixelsPlaced <= 0}"
				>
					<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
						<path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
					</svg>
				</button>
				<div class="absolute left-1/2 -top-6 transform -translate-x-1/2 -translate-y-1/2 px-2 py-1 text-white bg-peps-dark-800 rounded opacity-0 group-hover:opacity-100 transition-opacity uppercase text-nowrap">
					{{ 'page.place.buttons.validated-pixels' | translate }}
					<div class="size-3 bg-peps-dark-800 absolute -bottom-1 left-1/2 -translate-x-1/2 rotate-45"></div>
				</div>
			</div>

			<div class="relative group inline-block">
				<button
					class="flex flex-row gap-2 mb-8 text-peps-dark-700 bg-peps-gold py-4 px-8 cursor-pointer transition-colors duration-300 uppercase"
					(click)="toggleColoursSelector()"
				>
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-6">
						<path fill-rule="evenodd" d="M20.599 1.5c-.376 0-.743.111-1.055.32l-5.08 3.385a18.747 18.747 0 0 0-3.471 2.987 10.04 10.04 0 0 1 4.815 4.815 18.748 18.748 0 0 0 2.987-3.472l3.386-5.079A1.902 1.902 0 0 0 20.599 1.5Zm-8.3 14.025a18.76 18.76 0 0 0 1.896-1.207 8.026 8.026 0 0 0-4.513-4.513A18.75 18.75 0 0 0 8.475 11.7l-.278.5a5.26 5.26 0 0 1 3.601 3.602l.502-.278ZM6.75 13.5A3.75 3.75 0 0 0 3 17.25a1.5 1.5 0 0 1-1.601 1.497.75.75 0 0 0-.7 1.123 5.25 5.25 0 0 0 9.8-2.62 3.75 3.75 0 0 0-3.75-3.75Z" clip-rule="evenodd" />
					</svg>
					<span>{{ 'page.place.buttons.draw' | translate }}</span>
					<span>{{ localPixelsAvailable() }}/ {{ placeTwitchUserContext()?.chargesInfo!.maxPixels }}</span>
					@if(localPixelsAvailable() != placeTwitchUserContext()?.chargesInfo!.maxPixels) {
						<span>{{ formatTimeRemaining() }}</span>
					}
				</button>
				<div class="absolute left-1/2 -top-6 transform -translate-x-1/2 -translate-y-1/2 px-2 py-1 text-white bg-peps-dark-800 rounded opacity-0 group-hover:opacity-100 transition-opacity uppercase text-nowrap">
					{{ 'page.place.buttons.open-color-selector' | translate }}
					<div class="size-3 bg-peps-dark-800 absolute -bottom-1 left-1/2 -translate-x-1/2 rotate-45"></div>
				</div>
			</div>

			@if(selectedColour()) {
				<div class="relative group inline-block">
				    <span
					    class="w-14 h-14 block"
					    [style.backgroundColor]="selectedColour()?.hexCode"
				    ></span>
					<div class="absolute left-1/2 -top-6 transform -translate-x-1/2 -translate-y-1/2 px-2 py-1 text-white bg-peps-dark-800 rounded opacity-0 group-hover:opacity-100 transition-opacity uppercase text-nowrap">
						{{ 'page.place.buttons.selected-color' | translate }}
						<div class="size-3 bg-peps-dark-800 absolute -bottom-1 left-1/2 -translate-x-1/2 rotate-45"></div>

					</div>
				</div>
			}
		} @else {
			<div class="relative group inline-block">
				<button
					class="flex flex-row gap-2 mb-8 text-peps-dark-700 bg-peps-gold py-4 px-8 cursor-pointer transition-colors duration-300 uppercase"
					*featureFlag="'AUTHENTICATION'"
					(click)="loginWithTwitch()"
				>{{ 'component.navbar.login' | translate }}</button>
			</div>
		}
	</div>

	@if(isShowingColoursSelector()){

		<div class="absolute -top- -translate-y-full left-1/2 -translate-x-1/2 w-6/12 px-2 py-4 bg-white border-4 border-peps-gold">
			<button
				class="bg-peps-dark-700 rounded-full p-2 absolute -top-6 z-10 cursor-pointer left-1/2 -translate-x-1/2"
				(click)="toggleColoursSelector()"
			>
				<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
					<path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
				</svg>
			</button>
			<div class="h-50 overflow-y-scroll w-full flex flex-row flex-wrap justify-center gap-2 custom-scrollbar">

				@for(colour of colours(); track $index) {
					<div class="relative">
						<button
							(click)="selectColor(colour)"
							class="size-8 cursor-pointer border-2 border-peps-dark-400 rounded-full"
							[ngClass]="{'border-peps-gold': colour === selectedColour()}"
							[style]="'background-color:'+colour.hexCode"
						></button>
						@if(!colour.isDefault && false) {
							<span class="absolute -bottom-1 -right-1 bg-peps-dark-200 rounded-full text-peps-red p-0.5" title="Verrouillé">
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4">
						  <path stroke-linecap="round" stroke-linejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z" />
						</svg>
					</span>
						}
					</div>

				}
			</div>

		</div>

	}
</div>

<peps-canvas
	[selectedColour]="selectedColour()"
	(pixelPlaced)="handlePixelPlaced($event)"
	(pixelRemoved)="handlePixelRemoved($event)"
	[availablePixels]="localPixelsAvailable"
	(pixelValidated)="pixelsValidated($event)"
	(pixelSelected)="handlePixelSelected($event)"
></peps-canvas>


@if(isLeaderboardModalOpen()) {
	<peps-place-leaderboard
		(close)="closeLeaderboardModal()"
	></peps-place-leaderboard>
}

@if(isChallengeModalOpen() && placeTwitchUserContext() != null) {
	<peps-place-challenge
		(close)="closeChallengeModal()"
		[challengesUserCompleted]="placeTwitchUserContext()!.completedChallenges"
	></peps-place-challenge>
}

@if(isInformationModalOpen()) {
	<peps-place-information
		(close)="closeInformationModal()"
	></peps-place-information>
}
